import { HTTP } from "@/api";

// Гостевой фолбэк: одно хранилище "favorites" (числовые BetsAPI matchId).
const LS_KEY = "favorites";

function readLocal() {
  return (localStorage.getItem(LS_KEY) || "")
    .split(",")
    .filter(Boolean)
    .map((v) => Number(v));
}

function writeLocal(ids) {
  localStorage.setItem(LS_KEY, ids.join(","));
}

export default {
  // Загрузка избранного: авторизован → сервер, гость → localStorage.
  fetchFavorites({ commit, state }) {
    if (!state.user) {
      commit("SET_FAVORITES", readLocal());
      return Promise.resolve();
    }
    return HTTP.get("/v2/favorites")
      .then((res) => {
        if (res.data && res.data.success) {
          commit("SET_FAVORITES", res.data.favorites);
        }
      })
      .catch((e) => console.log("fetchFavorites", e));
  },

  // Оптимистичный тоггл + синк. matchId = BetsAPI id (match.id / match._id).
  toggleFavorite({ commit, state }, id) {
    const matchId = Number(id);
    const wasFav = state.match.favorites.includes(matchId);
    commit("TOGGLE_FAVORITE", matchId); // оптимистично

    if (!state.user) {
      writeLocal(state.match.favorites);
      return Promise.resolve();
    }

    const req = wasFav
      ? HTTP.delete(`/v2/favorites/${matchId}`)
      : HTTP.post(`/v2/favorites/${matchId}`);

    return req.catch((e) => {
      commit("TOGGLE_FAVORITE", matchId); // откат при ошибке
      console.log("toggleFavorite", e);
    });
  },

  // Глобальные тумблеры типов пуш-событий.
  updatePushSettings(_, settings) {
    return HTTP.patch("/v2/user/push-settings", settings).then(
      (res) => res.data,
    );
  },
};
